import React from "react";
import { useState, useEffect, useCallback } from "react";

export default function (props = {}) {
  const [ref, setRef] = useState(null);
  const [open, setOpen] = useState(false);
  const [styles, setStyles] = useState({});
  const [options, setOptions] = useState({
    speed: props.speed || 300,
  });
  const setRefObject = useCallback(setRef, []);

  const openMenu = useCallback(() => {
    const speed = options.speed;

    setStyles({
      visibility: "",
      overflow: "hidden",
      transition: `height ${speed}ms linear, padding ${speed}ms linear`,
      height: options.height + "px",
    });
  }, [options]);

  const closeMenu = useCallback(
    (fast) => {
      const speed = fast ? 0 : options.speed;

      setStyles({
        overflow: "hidden",
        transition: `height ${speed}ms linear, padding ${speed}ms linear, visibility 0s linear ${speed}ms`,
        height: 0,
        paddingTop: 0,
        paddingBottom: 0,
        visibility: "hidden",
      });
    },
    [options]
  );

  useEffect(() => {
    if (ref && options.height === undefined) {
      setOptions({
        ...options,
        height: ref.offsetHeight,
      });
      closeMenu(true);
    }

    return () => setOpen(false);
  }, [ref]);

  useEffect(() => {
    if (options.height === undefined || options.height < 1) {
      return null;
    }

    open === true ? openMenu() : closeMenu();
  }, [open]);

  return [setRefObject, styles, open, setOpen];
}
